{
  "languages": {
    "arabic": "Arabă",
    "belarusian": "Belarusă",
    "chinese": "Chineză",
    "dutch": "Olandeză",
    "english": "Engleză",
    "french": "Franceză",
    "german": "Germană",
    "italian": "Italiană",
    "japanese": "Japoneză",
    "korean": "Coreeană",
    "lithuanian": "Lituaniană",
    "portuguese": "Portugheză",
    "romanian": "Română",
    "spanish": "Spaniolă",
    "turkish": "Turcă"
  }
}
